// extracted by mini-css-extract-plugin
export default {"section":"styles_section__Jy9Cn","container":"styles_container__F1X9u"};